module.exports = __webpack_public_path__ + "static/img/06.4a6068f8.png";